//# sourceMappingURL=model_assignments.mjs.map
/// <reference types="./model_assignments.d.mts" />
import * as $ai_config from "../../../data_types/data/ai_config.mjs";
import * as $organization from "../../../data_types/data/auth/organization.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $sh from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $ai_config_effects from "../../admin/effects/ai_config.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList, Empty as $Empty, prepend as listPrepend, isEqual } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";

const org_width = 220;

const cell_width = 260;

function categories() {
  return toList([
    [
      "Default Model",
      (c) => { return c.config.models_config.default_model; },
      $ai_config.set_default_model,
    ],
    [
      "Rag Model",
      (c) => { return c.config.models_config.rag; },
      $ai_config.set_rag_model,
    ],
    [
      "Search Model",
      (c) => { return c.config.models_config.search_model; },
      $ai_config.set_search_model,
    ],
    [
      "Agentic Loop Driver Model",
      (c) => { return c.config.models_config.agentic_loop_driver_model; },
      $ai_config.set_agentic_loop_driver_model,
    ],
    [
      "Translate Model",
      (c) => { return c.config.models_config.translate_model; },
      $ai_config.set_translate_model,
    ],
    [
      "Conversational Model",
      (c) => { return c.config.models_config.conversational_model; },
      $ai_config.set_conversational_model,
    ],
    [
      "Website Scrapping Model",
      (c) => { return c.config.models_config.website_scrapping_model; },
      $ai_config.set_website_scrapping_model,
    ],
    [
      "Rows/Columns Detection Model",
      (c) => { return c.config.models_config.rows_columns_detection_model; },
      $ai_config.set_rows_columns_detection_model,
    ],
    [
      "Advanced Cell Detection Model",
      (c) => { return c.config.models_config.advanced_cell_detection_model; },
      $ai_config.set_advanced_cell_detection_model,
    ],
    [
      "Docx Question Detection Model",
      (c) => { return c.config.models_config.docx_question_detection_model; },
      $ai_config.set_docx_question_detection_model,
    ],
    [
      "Website Capture Model",
      (c) => { return c.config.models_config.website_capture_model; },
      $ai_config.set_website_capture_model,
    ],
  ]);
}

function plural(count, word) {
  return (($int.to_string(count) + " ") + word) + (() => {
    if (count === 1) {
      return "";
    } else {
      return "s";
    }
  })();
}

function count_label(changes, org_count) {
  return (plural($list.length(changes), "change") + " across ") + plural(
    org_count,
    "organization",
  );
}

function apply_bar(changes, on_discard, on_review) {
  let _block;
  let _pipe = $list.map(changes, (change) => { return change[0].id; });
  let _pipe$1 = $set.from_list(_pipe);
  _block = $set.size(_pipe$1);
  let org_count = _block;
  return $l.row(
    toList([
      $l.gap(16),
      $l.align("center"),
      $l.justify("space-between"),
      $l.padding(12),
      $l.position("sticky"),
      $l.styles(
        toList([
          $css.bottom(px(12)),
          $css.background($colors.light.text_white),
          $css.border("1px solid " + $colors.light.ai_400),
          $css.border_radius(px(10)),
        ]),
      ),
    ]),
    toList([]),
    toList([
      $typography.text(
        $typography.sm,
        $typography.medium,
        count_label(changes, org_count),
      ),
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $button.secondary(
            toList([$e.on_click(on_discard)]),
            toList([$h.text("Discard")]),
          ),
          $button.primary(
            toList([$e.on_click(on_review)]),
            toList([$h.text("Review changes")]),
          ),
        ]),
      ),
    ]),
  );
}

function header_text(text) {
  return $typography.text($typography.xs, $typography.medium, text);
}

function head_cell_style(sticky_left, background, border) {
  return $css.class$(
    toList([
      (() => {
        if (sticky_left) {
          return $css.position("sticky");
        } else {
          return $css.none();
        }
      })(),
      (() => {
        if (sticky_left) {
          return $css.left(px(0));
        } else {
          return $css.none();
        }
      })(),
      $css.z_index(
        (() => {
          if (sticky_left) {
            return 4;
          } else {
            return 3;
          }
        })(),
      ),
      $css.padding_("10px 12px"),
      $css.text_align("left"),
      $css.vertical_align("top"),
      $css.white_space("nowrap"),
      $css.background(background),
      $css.border_bottom("1px solid " + border),
    ]),
  );
}

function header_style(sticky_left) {
  return head_cell_style(
    sticky_left,
    $colors.light.grey_100,
    $colors.light.grey_200,
  );
}

function header_row() {
  return $sh.tr(
    $css.class$(toList([])),
    toList([]),
    listPrepend(
      $sh.th(
        header_style(true),
        toList([]),
        toList([header_text("Organization")]),
      ),
      $list.map(
        categories(),
        (category) => {
          return $sh.th(
            header_style(false),
            toList([]),
            toList([header_text(category[0])]),
          );
        },
      ),
    ),
  );
}

function thead_style() {
  return $css.class$(
    toList([$css.position("sticky"), $css.top(px(0)), $css.z_index(3)]),
  );
}

function table_style() {
  return $css.class$(
    toList([
      $css.border_collapse("separate"),
      $css.border_spacing(px(0)),
      $css.min_width_("100%"),
    ]),
  );
}

function table_shell(children) {
  let _pipe = toList([
    $l.overflow("auto"),
    $l.styles(
      toList([
        $css.max_height_("calc(100vh - 280px)"),
        $css.background($colors.light.text_white),
        $css.border("1px solid " + $colors.light.grey_200),
        $css.border_radius(px(10)),
      ]),
    ),
  ]);
  return $l.column(_pipe, toList([]), children);
}

function change_key(change) {
  let org;
  let label;
  org = change[0];
  label = change[1][0];
  return [org.id, label];
}

function loaded_config(configs, org_id) {
  let _pipe = $dict.get(configs, org_id);
  return $result.try$(_pipe, $remote.read);
}

function apply_changes(changes, configs, dispatch) {
  return $dict.each(
    $list.group(changes, (change) => { return change[0].id; }),
    (org_id, org_changes) => {
      let $ = loaded_config(configs, org_id);
      if ($ instanceof Ok) {
        let config = $[0];
        let updated = $list.fold(
          org_changes,
          config,
          (config, change) => {
            let set;
            let new$;
            new$ = change[3];
            set = change[1][2];
            return set(config, new$);
          },
        );
        dispatch($ai_config_effects.set_ai_config(updated));
        return undefined;
      } else {
        return undefined;
      }
    },
  );
}

function matches_search(org, search) {
  let search$1 = $string.lowercase($string.trim(search));
  return $bool.guard(
    search$1 === "",
    true,
    () => {
      let _pipe = toList([org.display_name, org.name, org.id]);
      return $list.any(
        _pipe,
        (field) => {
          return $string.contains($string.lowercase(field), search$1);
        },
      );
    },
  );
}

function result_to_list(result, next) {
  if (result instanceof Ok) {
    let value = result[0];
    return next(value);
  } else {
    return toList([]);
  }
}

/**
 * Pending entries whose value already matches the stored config (e.g. once a
 * save succeeds) are not changes anymore, so they are filtered out here.
 * 
 * @ignore
 */
function pending_changes(pending, organizations, configs) {
  return $list.flat_map(
    organizations,
    (org) => {
      return result_to_list(
        loaded_config(configs, org.id),
        (config) => {
          return $list.filter_map(
            categories(),
            (category) => {
              let label = category[0];
              let get = category[1];
              return $result.try$(
                $dict.get(pending, [org.id, label]),
                (new$) => {
                  let old = get(config);
                  return $bool.guard(
                    isEqual(old, new$),
                    new Error(undefined),
                    () => { return new Ok([org, category, old, new$]); },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function use_fetch_ai_configs(organizations, dispatch) {
  return ((_capture) => {
    return $redraw.use_effect(_capture, [$list.length(organizations)]);
  })(
    () => {
      if (organizations instanceof $Empty) {
        return undefined;
      } else {
        dispatch($ai_config_effects.fetch_ai_configs());
        return undefined;
      }
    },
  );
}

function sorted_model_choices() {
  let _pipe = $list.sort(
    $ai_config.all_models,
    (a, b) => {
      return $string.compare(
        $ai_config.model_to_string(a),
        $ai_config.model_to_string(b),
      );
    },
  );
  return $list.map(
    _pipe,
    (model) => {
      return $dropdown.choice($ai_config.model_to_string(model), model);
    },
  );
}

function count_label_short(changes) {
  return ("(" + $int.to_string($list.length(changes))) + ")";
}

function diff_row(change, on_remove) {
  let org;
  let label;
  let old;
  let new$;
  org = change[0];
  old = change[2];
  new$ = change[3];
  label = change[1][0];
  return $l.row(
    toList([
      $l.gap(12),
      $l.align("center"),
      $l.justify("space-between"),
      $l.padding(10),
      $l.styles(
        toList([
          $css.border("1px solid " + $colors.light.grey_200),
          $css.border_radius(px(8)),
          $css.background($colors.light.grey_50),
        ]),
      ),
    ]),
    toList([]),
    toList([
      $l.column(
        toList([$l.gap(2)]),
        toList([]),
        toList([
          $typography.text(
            $typography.sm,
            $typography.medium,
            (org.display_name + " · ") + label,
          ),
          $typography.text(
            $typography.xs,
            $typography.regular,
            ($ai_config.model_to_string(old) + " → ") + $ai_config.model_to_string(
              new$,
            ),
          ),
        ]),
      ),
      $button.ghost(toList([on_remove]), toList([$h.text("Remove")])),
    ]),
  );
}

function review_changes() {
  return $redraw.component_(
    "ReviewModelChanges",
    (_use0) => {
      let changes = _use0[0];
      let props = _use0[1];
      let $ = $redraw.use_state($set.new$());
      let removed = $[0];
      let set_removed = $[1];
      let _block;
      let _pipe = changes;
      let _pipe$1 = $list.filter(
        _pipe,
        (change) => { return !$set.contains(removed, change_key(change)); },
      );
      _block = $list.sort(
        _pipe$1,
        (a, b) => {
          let _pipe$2 = $string.compare(a[0].display_name, b[0].display_name);
          return $order.lazy_break_tie(
            _pipe$2,
            () => { return $string.compare(a[1][0], b[1][0]); },
          );
        },
      );
      let kept = _block;
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(kept)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$modal.large(), $utils.stop_propagation()]),
            toList([
              $modal.title(toList([]), toList([$h.text("Review changes")])),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "Every change below is written to its organization's AI ",
                  ),
                  $h.text(
                    "config as soon as you confirm. Remove any you don't want to ",
                  ),
                  $h.text("apply yet."),
                ]),
              ),
              $redraw.keyed(
                (_capture) => {
                  return $l.column(
                    toList([
                      $l.gap(8),
                      $l.overflow("auto"),
                      $l.styles(toList([$css.max_height(px(360))])),
                    ]),
                    toList([]),
                    _capture,
                  );
                },
                $list.map(
                  kept,
                  (change) => {
                    let $1 = change_key(change);
                    let org_id = $1[0];
                    let label = $1[1];
                    let on_remove = $e.on_click(
                      (_) => {
                        return set_removed(
                          $set.insert(removed, change_key(change)),
                        );
                      },
                    );
                    return [org_id + label, diff_row(change, on_remove)];
                  },
                ),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Keep editing")]),
                  ),
                  $button.primary(
                    toList([$a.disabled(isEqual(kept, toList([]))), on_confirm]),
                    toList([
                      $h.text("Confirm & apply " + count_label_short(kept)),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function set_all_style(sticky_left) {
  return head_cell_style(sticky_left, $colors.light.ai_50, $colors.light.ai_200);
}

function dropdown_input_style() {
  return $css.class$(
    toList([
      $css.font_size(px(12)),
      $css.overflow("hidden"),
      $css.text_overflow("ellipsis"),
      $css.white_space("nowrap"),
    ]),
  );
}

function set_all_row() {
  return $redraw.compose(
    $dropdown.dropdown(),
    (model_dropdown) => {
      return $redraw.component_(
        "ModelAssignmentsSetAllRow",
        (_use0) => {
          let target_count = _use0[0];
          let choices = _use0[1];
          let on_set_all = _use0[2];
          return $sh.tr(
            $css.class$(toList([])),
            toList([]),
            listPrepend(
              $sh.th(
                set_all_style(true),
                toList([]),
                toList([
                  $l.column(
                    toList([$l.gap(2)]),
                    toList([]),
                    toList([
                      header_text("Set for all"),
                      $typography.text(
                        $typography.xs,
                        $typography.regular,
                        plural(target_count, "shown organization"),
                      ),
                    ]),
                  ),
                ]),
              ),
              $list.map(
                categories(),
                (category) => {
                  let _block;
                  let _pipe = $dropdown.on_selected_(
                    (model) => { return on_set_all(category, model); },
                  );
                  let _pipe$1 = $dropdown.placeholder(_pipe, "Set all…");
                  let _pipe$2 = $dropdown.selected(_pipe$1, new None());
                  let _pipe$3 = $dropdown.disabled(_pipe$2, target_count === 0);
                  let _pipe$4 = $dropdown.show_arrow(_pipe$3, true);
                  let _pipe$5 = $dropdown.searchable(_pipe$4, true);
                  let _pipe$6 = $dropdown.small(_pipe$5, true);
                  _block = $dropdown.input_class(
                    _pipe$6,
                    dropdown_input_style(),
                  );
                  let props = _block;
                  return $sh.th(
                    set_all_style(false),
                    toList([]),
                    toList([model_dropdown([props, choices])]),
                  );
                },
              ),
            ),
          );
        },
      );
    },
  );
}

function org_cell_style() {
  return $css.class$(
    toList([
      $css.position("sticky"),
      $css.left(px(0)),
      $css.z_index(2),
      $css.min_width(px(org_width)),
      $css.max_width(px(org_width)),
      $css.padding_("10px 12px"),
      $css.vertical_align("top"),
      $css.background($colors.light.text_white),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
      $css.border_right("1px solid " + $colors.light.grey_200),
    ]),
  );
}

function cell_style(dirty) {
  return $css.class$(
    toList([
      $css.min_width(px(cell_width)),
      $css.max_width(px(cell_width)),
      $css.padding_("8px 12px"),
      $css.vertical_align("top"),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
      $css.background(
        (() => {
          if (dirty) {
            return $colors.light.ai_50;
          } else {
            return "transparent";
          }
        })(),
      ),
    ]),
  );
}

function model_cell(dropdown, current, selected) {
  let dirty = !isEqual(selected, current);
  return $sh.td(
    cell_style(dirty),
    toList([]),
    toList([
      $l.column(
        toList([$l.gap(4)]),
        toList([]),
        toList([
          dropdown,
          (() => {
            if (dirty) {
              return $typography.text(
                $typography.xs,
                $typography.regular,
                "was " + $ai_config.model_to_string(current),
              );
            } else {
              return $h.none();
            }
          })(),
        ]),
      ),
    ]),
  );
}

function org_row() {
  return $redraw.compose(
    $dropdown.dropdown(),
    (model_dropdown) => {
      return $redraw.component_(
        "ModelAssignmentsRow",
        (_use0) => {
          let org = _use0[0];
          let config = _use0[1];
          let pending = _use0[2];
          let choices = _use0[3];
          let on_select = _use0[4];
          let _block;
          if (config instanceof $remote.NotLoaded) {
            _block = $list.map(
              categories(),
              (_) => {
                return $sh.td(
                  cell_style(false),
                  toList([]),
                  toList([$skeleton.skeleton(200, 28)]),
                );
              },
            );
          } else if (config instanceof $remote.Loading) {
            _block = $list.map(
              categories(),
              (_) => {
                return $sh.td(
                  cell_style(false),
                  toList([]),
                  toList([$skeleton.skeleton(200, 28)]),
                );
              },
            );
          } else if (config instanceof $remote.Errored) {
            _block = toList([
              $sh.td(
                cell_style(false),
                toList([$a.col_span($list.length(categories()))]),
                toList([header_text("No AI config for this organization")]),
              ),
            ]);
          } else {
            let config$1 = config[0];
            _block = $list.map(
              categories(),
              (category) => {
                let label = category[0];
                let get = category[1];
                let current = get(config$1);
                let _block$1;
                let _pipe = $dict.get(pending, [org.id, label]);
                _block$1 = $result.unwrap(_pipe, current);
                let selected = _block$1;
                let _block$2;
                let _pipe$1 = $dropdown.on_selected_(
                  (model) => { return on_select(org.id, label, current, model); },
                );
                let _pipe$2 = $dropdown.selected(_pipe$1, new Some(selected));
                let _pipe$3 = $dropdown.show_arrow(_pipe$2, true);
                let _pipe$4 = $dropdown.searchable(_pipe$3, true);
                let _pipe$5 = $dropdown.small(_pipe$4, true);
                _block$2 = $dropdown.input_class(
                  _pipe$5,
                  dropdown_input_style(),
                );
                let props = _block$2;
                return model_cell(
                  model_dropdown([props, choices]),
                  current,
                  selected,
                );
              },
            );
          }
          let cells = _block;
          return $sh.tr(
            $css.class$(toList([])),
            toList([]),
            listPrepend(
              $sh.td(
                org_cell_style(),
                toList([]),
                toList([
                  $l.column(
                    toList([$l.gap(2)]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        org.display_name,
                      ),
                      $typography.text(
                        $typography.xs,
                        $typography.regular,
                        org.id,
                      ),
                    ]),
                  ),
                ]),
              ),
              cells,
            ),
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    org_row(),
    (org_row) => {
      return $redraw.compose(
        set_all_row(),
        (set_all_row) => {
          return $redraw.compose(
            review_changes(),
            (review_changes) => {
              return $redraw.component_(
                "ModelAssignments",
                (_) => {
                  let store = $store.use_state();
                  let dispatch = $store.use_effect_dispatch();
                  let modal = $modal.use_modal();
                  let $ = $redraw.use_state("");
                  let search = $[0];
                  let set_search = $[1];
                  let $1 = $redraw.use_state_($dict.new$());
                  let pending = $1[0];
                  let set_pending = $1[1];
                  let choices = $redraw.use_memo(sorted_model_choices, []);
                  let configs = store.organizations_ai_config;
                  let _block;
                  let $2 = store.organizations;
                  if ($2 instanceof $remote.Loaded) {
                    let organizations = $2[0][1];
                    _block = organizations;
                  } else {
                    _block = toList([]);
                  }
                  let organizations = _block;
                  use_fetch_ai_configs(organizations, dispatch);
                  let changes = pending_changes(pending, organizations, configs);
                  let on_select = (org_id, label, current, model) => {
                    return set_pending(
                      (pending) => {
                        let $3 = isEqual(model, current);
                        if ($3) {
                          return $dict.delete$(pending, [org_id, label]);
                        } else {
                          return $dict.insert(pending, [org_id, label], model);
                        }
                      },
                    );
                  };
                  let visible = $list.filter(
                    organizations,
                    (_capture) => { return matches_search(_capture, search); },
                  );
                  let set_all_targets = $list.filter(
                    visible,
                    (org) => {
                      return $result.is_ok(loaded_config(configs, org.id));
                    },
                  );
                  let on_set_all = (category, model) => {
                    let label = category[0];
                    let get = category[1];
                    return set_pending(
                      (pending) => {
                        return $list.fold(
                          set_all_targets,
                          pending,
                          (pending, org) => {
                            let $3 = loaded_config(configs, org.id);
                            if ($3 instanceof Ok) {
                              let config = $3[0];
                              let $4 = isEqual(get(config), model);
                              if ($4) {
                                return $dict.delete$(pending, [org.id, label]);
                              } else {
                                return $dict.insert(
                                  pending,
                                  [org.id, label],
                                  model,
                                );
                              }
                            } else {
                              return pending;
                            }
                          },
                        );
                      },
                    );
                  };
                  let on_discard = (_) => {
                    return set_pending((_) => { return $dict.new$(); });
                  };
                  let on_review = (_) => {
                    $promise.map(
                      modal.open(
                        (props) => { return review_changes([changes, props]); },
                      ),
                      (result) => {
                        return $result.map(
                          result,
                          (kept) => {
                            apply_changes(kept, configs, dispatch);
                            return set_pending(
                              (pending) => {
                                return $dict.filter(
                                  pending,
                                  (key, _) => {
                                    return $list.any(
                                      kept,
                                      (change) => {
                                        return isEqual(change_key(change), key);
                                      },
                                    );
                                  },
                                );
                              },
                            );
                          },
                        );
                      },
                    );
                    return undefined;
                  };
                  return $l.column(
                    toList([$l.gap(16)]),
                    toList([]),
                    toList([
                      $common.page_title("Model assignments"),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        "Set the LLM used for each category across every organization. " + "Changes stay local until you review and confirm them.",
                      ),
                      $l.row(
                        toList([
                          $l.gap(16),
                          $l.align("center"),
                          $l.justify("space-between"),
                        ]),
                        toList([]),
                        toList([
                          $l.row(
                            toList([$l.styles(toList([$css.width(px(320))]))]),
                            toList([]),
                            toList([
                              $input.input(
                                (() => {
                                  let _pipe = $input.value(search);
                                  let _pipe$1 = $input.placeholder(
                                    _pipe,
                                    "Search by organization name or org_id…",
                                  );
                                  return $input.on_input(_pipe$1, set_search);
                                })(),
                              ),
                            ]),
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            ((("Showing " + $int.to_string(
                              $list.length(visible),
                            )) + " of ") + $int.to_string(
                              $list.length(organizations),
                            )) + " organizations",
                          ),
                        ]),
                      ),
                      (() => {
                        let $3 = store.organizations;
                        if ($3 instanceof $remote.Loaded) {
                          return table_shell(
                            toList([
                              $sh.table(
                                table_style(),
                                toList([]),
                                toList([
                                  $sh.thead(
                                    thead_style(),
                                    toList([]),
                                    toList([
                                      header_row(),
                                      set_all_row(
                                        [
                                          $list.length(set_all_targets),
                                          choices,
                                          on_set_all,
                                        ],
                                      ),
                                    ]),
                                  ),
                                  $redraw.keyed(
                                    (_capture) => {
                                      return $sh.tbody(
                                        $css.class$(toList([])),
                                        toList([]),
                                        _capture,
                                      );
                                    },
                                    $list.map(
                                      visible,
                                      (org) => {
                                        let _block$1;
                                        let _pipe = $dict.get(configs, org.id);
                                        _block$1 = $result.unwrap(
                                          _pipe,
                                          new $remote.NotLoaded(),
                                        );
                                        let config = _block$1;
                                        return [
                                          org.id,
                                          org_row(
                                            [
                                              org,
                                              config,
                                              pending,
                                              choices,
                                              on_select,
                                            ],
                                          ),
                                        ];
                                      },
                                    ),
                                  ),
                                ]),
                              ),
                            ]),
                          );
                        } else {
                          return $skeleton.full_width(400);
                        }
                      })(),
                      (() => {
                        if (changes instanceof $Empty) {
                          return $h.none();
                        } else {
                          return apply_bar(changes, on_discard, on_review);
                        }
                      })(),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
